import { withInstall } from '@lit-element/utils'
import Progress from './src/progress.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtProgress: SFCWithInstall<typeof Progress> = withInstall(Progress)
export default LtProgress

export * from './src/progress'
